module.exports = __webpack_public_path__ + "static/media/cladding-spraying-001-thumbnail.92f788e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/thumbnails/cladding-spraying-001-thumbnail.jpg
// module id = 109
// module chunks = 0